module.exports = __webpack_public_path__ + "img/Animales-RKU10.f7df5308.png";